module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"select":"Select your pattern"},"fr":{"select":"Sélectionnez votre motif"},"pl":{"select":"Wybierz wzór"},"de":{"select":"Wählen Sie das Lochmuster"}}')
  delete Component.options._Ctor
}
